import { useQuery } from '@tanstack/react-query';

import { getLabs, Lab } from 'api/labs';
import { useAppSelector } from 'redux/hooks';

export const labsQueryKey = ['labs'];

export const getLabsQueryKey = (includeArchived: boolean) => [...labsQueryKey, { includeArchived }];

export const useLabs = ({
  enabled = true,
  includeArchived = false,
}: { enabled?: boolean; includeArchived?: boolean } = {}) => {
  const accessToken = useAppSelector((state) => state.auth.accessToken);

  return useQuery<Lab[]>({
    queryKey: getLabsQueryKey(includeArchived),
    queryFn: ({ signal }) => getLabs({ signal, includeArchived }),
    enabled: enabled && Boolean(accessToken),
  });
};
